import styled from 'styled-components'

export const Boxes = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 2rem;
`



// WEBPACK FOOTER //
// ./src/components/Elements/Boxes.js